import * as Yup from "yup";
import OtrosForm from "./formModel";
import {isValidPhoneNumber} from "react-phone-number-input";

const {
    formField: {
        name,
        lastName,
        phone,
        email,
        codLocalidad,
        dni,
        idProducto
    },
} = OtrosForm;

export default [
    Yup.object().shape({
        [name.name]: Yup.string()
            .required(`${name.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [lastName.name]: Yup.string()
            .required(`${lastName.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
            .max(40, "El apellido ingresado es muy largo"),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
        [phone.name]: Yup.string()
            .test('telefono', "El celular ingresado no es válido",
                (value) => {
                    if (value && typeof value === "string")
                        return (isValidPhoneNumber(value))
                    else return false
                }
            ),
        [codLocalidad.name]: Yup.string().required(`${codLocalidad.requiredErrorMsg}`)
            .test('codLocalidad', "Seleccione una localidad válida",
                (value) => {
                    if (value) return value.includes(",")
                    else return false
                }),
        [dni.name]: Yup.number()
            .required(`${dni.requiredErrorMsg}`)
            .min(1000000, "El documento ingresado no es válido")
            .max(99999999, "El documento ingresado no es válido")
            .integer()
            .typeError("Introduzca únicamente números"),
    }),
    Yup.object().shape({
        [idProducto.name]: Yup.string().required(`${idProducto.requiredErrorMsg}`).test(
            'selectedProduct',
            'Por favor seleccione un producto',
            (value, context) => {
                return context.parent.idProducto !== null;
            }
        ),
    })
];